(ns iris.login.styles
  (:require
   ;;    [herb.core :refer [<class <id]]
   ;;  [garden.units :refer [px]]
   [shadow.css :refer [css]]))


(def $form-signin
  (css {:max-width "330px"
        :padding "15px"
        :margin "0 auto"}))

(def $account-wall
  (css {:margin-top "20px"
        :padding "40px 0px 20px 0px"
        :background-color "#f7f7f7"
        :box-shadow "0px 2px 2px rgb(0 0 0 / 30%)"}))

(def $login-title
  (css {:color "#555"
        :font-size "18px"
        :font-weight "400"
        :display "block"}))

(def $profile-img
  (css {:width "96px"
        :height "96px"
        :margin "0 auto 10px"
        :display "block"
        :border-radius "50%"}))

(def $btn-block
  (css {:display "block"
        :width "100%"
        :padding-right "0"
        :padding-left "0"
        :margin-top "10px"}))

(def $checkbox
  (css {:display "block !important"
        :min-height "20px !important"
        ;; :padding-left "20px !important"
        :margin-top "10px !important"
        :margin-bottom "5px !important"
        :vertical-align "middle !important"}
       ["&>input" {:position "initial !important"}])
  )

(def $input-box
  (css {:position "relative !important"
        :font-size "16px !important"
        :height "auto !important"
        :padding "10px !important"
        :box-sizing "border-box !important"}))

(def $username-input-box
  [$input-box
   (css {:margin-bottom "-1px"
         :border-bottom-left-radius "0 !important"
         :border-bottom-right-radius "0 !important"})])

(def $password-input-box
  [$input-box
   (css {:margin-bottom "10px"
         :border-top-left-radius "0 !important"
         :border-top-right-radius "0 !important"})])


;; (defn form-signin []
;;   {:max-width "330px"
;;    :padding "15px"
;;    :margin "0 auto"})

;; (defn account-wall []
;;   {:margin-top "20px"
;;    :padding "40px 0px 20px 0px"
;;    :background-color "#f7f7f7"
;;    :box-shadow "0px 2px 2px rgb(0 0 0 / 30%)"})

;; (defn login-title []
;;   {:color "#555"
;;    :font-size "18px"
;;    :font-weight "400"
;;    :display "block"})

;; (defn profile-img []
;;   {:width "96px"
;;    :height "96px"
;;    :margin "0 auto 10px"
;;    :display "block"
;;    :border-radius "50%"})

;; (defn btn-block []
;;   {:display "block"
;;    :width "100%"
;;    :padding-right "0"
;;    :padding-left "0"
;;    :margin-top "10px"})

;; (defn checkbox []
;;   {:display "block"
;;    :min-height "20px"
;;    :padding-left "20px"
;;    :margin-top "10px"
;;    :margin-bottom "5px"
;;    :vertical-align "middle"})

;; (defn input-box []
;;   {:position "relative"
;;    :font-size "16px"
;;    :height "auto"
;;    :padding "10px"
;;    :box-sizing "border-box"})

;; (defn username-input-box []
;;   ^{:extend [input-box]}
;;   {:margin-bottom "-1px"
;;    :border-bottom-left-radius "0"
;;    :border-bottom-right-radius "0"})

;; (defn password-input-box []
;;   ^{:extend [input-box]}
;;   {:margin-bottom "10px"
;;    :border-top-left-radius "0"
;;    :border-top-right-radius "0"})